import React, {useState} from 'react';
import {Form, Input} from "antd";
import cx from "classnames";
import {SearchOutlined} from '@ant-design/icons';

import './styles.scss';

import Button from "../../common/Button/Button";
import {TemplateFilterFormTypes} from "./Types";

interface Props {
    onSubmit?: (values: any) => void,
    disabledFilters?: TemplateFilterFormTypes[]
}

function TemplateFilters(props: Props) {
    const {onSubmit, disabledFilters} = props;
    const [form] = Form.useForm();
    const [submittingForm, setSubmittingForm] = useState(false);
    const {Name} = TemplateFilterFormTypes;

    async function onFormSubmit(values: any) {
        if (submittingForm) return false;
        setSubmittingForm(true);
        try {
            let valid = await form.validateFields();
            if (!valid.errorFields && onSubmit) {
                onSubmit(values);
            }
        } catch (e) {

        }
        setSubmittingForm(false);
    }

    const formProps = {
        requiredMark: 'optional',
        colon: false,
        className: cx('template-filters-form')
    };

    function isDisabled(name: TemplateFilterFormTypes) {
        return disabledFilters && disabledFilters.indexOf(name) !== -1;
    }

    return (
        <div className='template-filters-form-wrapper'>
            <Form {...formProps} onFinish={onFormSubmit} layout='vertical' form={form}>
                {!isDisabled(Name) &&
                <Form.Item name={Name}>
                    <Input size='large' placeholder='Search template by name'/>
                </Form.Item>}
                <Form.Item>
                    <Button htmlType='submit' icon={<SearchOutlined/>}>
                        Search
                    </Button>
                </Form.Item>
            </Form>
        </div>
    )
}

export default TemplateFilters;